import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/Delete";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import { PatronContext } from "../../contexts/PatronContext";
import { PaneContext } from "../../contexts/PaneContext";
import { UserContext } from "../../contexts/UserContext";
import { Button } from "../ui/forms/Button";
import Axios from "axios";
import { useSnackbar } from "notistack";

const PhotoPreview = () => {
  const [img, setImg] = useState(null);
  const { apiUrl } = useContext(DatabaseContext);
  const { Site } = useContext(UserContext);
  const { previewPanePhoto, updatePreviewPane } = useContext(PaneContext);
  const { patron, removePhoto } = useContext(PatronContext);
  const { enqueueSnackbar } = useSnackbar();
  const { externalID, firstName, lastName, hasPhoto } = patron || {};
  const patronLabel =
    Site?.siteType === 0 || Site?.siteType === 5 ? "student" : "staff";

  useEffect(() => {
    if (previewPanePhoto) {
      setImg(previewPanePhoto);
    } else if (hasPhoto && externalID) {
      // Constructs the default image URL if patron has an existing photo on file
      setImg(
        `${apiUrl}/api/photos/${Site?.siteCode}/${externalID}?t=${Date.now()}`,
      );
    } else {
      setImg(null);
    }
  }, [previewPanePhoto, externalID, hasPhoto, apiUrl, Site?.siteCode]);

  const handleRemovePhoto = async () => {
    try {
      await removePhoto(externalID);
      setImg(null);
      updatePreviewPane(null);
    } catch (err) {
      enqueueSnackbar("Failed to remove photo", { variant: "error" });
    }
  };

  return img ? (
    <Container>
      <Name>
        {patron ? `${firstName} ${lastName}` : `No ${patronLabel} selected`}
      </Name>
      <img
        style={{ maxWidth: "100%", borderRadius: "1rem" }}
        src={img}
        alt={externalID || "Preview"}
        onError={() => setImg(null)}
        onContextMenu={(e) => e.preventDefault()}
      />
      <Button
        colour="error"
        startIcon={<DeleteIcon />}
        onClick={handleRemovePhoto}
        margin="2rem"
      >
        Remove photo
      </Button>
    </Container>
  ) : (
    <Container>
      <Name>
        {patron ? `${firstName} ${lastName}` : `No ${patronLabel} selected`}
      </Name>
      <div>No Photo</div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Name = styled.p`
  font-size: 2rem;
  font-weight: 700;
  font-style: italic;
  align-self: flex-end;
  margin-bottom: 2rem;
`;

export default PhotoPreview;
